import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Livrare',
    pickup: 'Ridicare',
  },
  asap: 'Cât mai curând',
  unavailable: 'Indisponibil',
  ready_in_time: 'Gata în {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Livrare la {{address}}',
    [ORDER_METHODS.PICKUP]: 'Ridicare de la {{address}}',
  },
  buttons: {
    change: 'Schimbă',
    see_hours: 'Vezi programul',
    change_location: 'Schimbă locația',
    change_time: 'Schimbă ora',
  },
};
